import { render, staticRenderFns } from "./GeTarget.vue?vue&type=template&id=ddcd2958&scoped=true"
import script from "./GeTarget.vue?vue&type=script&lang=js"
export * from "./GeTarget.vue?vue&type=script&lang=js"
import style0 from "./GeTarget.vue?vue&type=style&index=0&id=ddcd2958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcd2958",
  null
  
)

export default component.exports